import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

type LanguageMeta = { code: string; dir: 'rtl' | 'ltr' };

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private readonly storageKey = 'app-language';
  private readonly languages: LanguageMeta[] = [
    { code: 'he', dir: 'rtl' },
    { code: 'fr', dir: 'ltr' },
    { code: 'en', dir: 'ltr' },
    { code: 'ru', dir: 'ltr' }
  ];

  constructor(private translate: TranslateService) {}

  initLanguage(): void {
    const saved = this.getSavedLanguage() || 'fr';
    this.translate.addLangs(this.languages.map(l => l.code));
    this.translate.setDefaultLang('fr');
    this.setLanguage(saved);
  }

  setLanguage(code: string): void {
    const meta = this.languages.find(l => l.code === code) ?? this.languages[0];
    this.translate.use(meta.code);
    document.documentElement.lang = meta.code;
    document.documentElement.dir = meta.dir;
    localStorage.setItem(this.storageKey, meta.code);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || this.translate.defaultLang || 'he';
  }

  getAvailableLanguages(): ReadonlyArray<LanguageMeta> {
    return this.languages;
  }

  private getSavedLanguage(): string | null {
    try {
      return localStorage.getItem(this.storageKey);
    } catch {
      return null;
    }
  }
}

